export const resolvePrimaryHighlightObjectType = ({ contentType, objectType }) => {
  if (contentType?.includes?.('QuestionAndAnswer') || contentType === 'QuestionAndAnswer') {
    return 'WrittenQuestion';
  }
  return objectType;
};

export const applyHighlightedPayload = ({ content, highlightedData, titleField, bodyField, titleFallbackField }) => {
  let newData = { ...content };
  if (!highlightedData) {
    return newData;
  }

  const { highlightedTitle, highlightedHtmlBody } = highlightedData;

  if (highlightedTitle && titleField) {
    newData[titleField] = highlightedTitle;
  } else if (titleField && titleFallbackField) {
    newData[titleField] = newData?.[titleFallbackField];
  }

  if (highlightedHtmlBody && bodyField) {
    newData[bodyField] = highlightedHtmlBody;
  }

  return newData;
};

export const applyAnswerHighlight = ({ content, highlightedAnswer, answerField = 'answerText' }) => {
  if (!highlightedAnswer?.highlightedHtmlBody) {
    return { ...content };
  }
  return { ...content, [answerField]: highlightedAnswer.highlightedHtmlBody };
};

export const applyQuestionAnswerHighlightedPayload = ({
  content,
  highlightedQuestion,
  highlightedAnswer,
  titleFallbackField = 'title',
  questionField = 'questionText',
  answerField = 'answerText',
}) => {
  return {
    ...content,
    questionForHighlighted: highlightedQuestion?.highlightedTitle ?? content?.[titleFallbackField],
    [questionField]: highlightedQuestion?.highlightedHtmlBody ?? content?.[questionField],
    [answerField]: highlightedAnswer?.highlightedHtmlBody ?? content?.[answerField],
  };
};

